import * as yup from "yup";
import {
    ICheckEquipmentsForm,
    IDamageSelector, IEquipmentCommentForm,
    IEventCardForm,
    IEventSelector, IRaVehicleIdentificationForm, IVehicleStatusForm
} from "../models/models";
import {ELECTRIC_ENGINE_POWER_CODE, TERMIC_HYBRID_ENGINE_POWER_CODE} from "../config";
import dayjs from "dayjs";

export const MAX_NUM_DAMAGE_ATTACH_FILES = 2;
export const MAX_NUM_EQUIPMENTS_COMMENTS = 5;

export const THEFT_REASON_CODE = 'STO';

export const VEHICLE_STATUS_FILE_UPLOAD_NAME = {
    km: 'KM_ON_CHECK',
    termic: 'TERMIC_LEVEL_ONCHECK',
    soc: 'SOC_LEVEL_ONCHECK'
}

export const EVENT_ATTACHMENT_TYPE = {
    id: 3,
    tenant: null,
    descr: "Documento",
    code: " DOC"
}

export const EVENT_MODULES_CODE = {
    cai: 'CAI',
    den: 'DICHIARAZIONE_CLIENTE'
}

export const REG_EXPRESSION_INPUT_FLOAT_NUMBER = /^[+-]?([0-9]+([\u002C][0-9]{0,2})?|[.][0-9]+)$/gm;
export const REG_EXPRESSION_INPUT_INTEGER_NUMBER = /^\d+$/;

/** Vehicle Status */
export const VEHICLE_STATUS_INITIAL_VALUE: IVehicleStatusForm = {
    now:                        null,
    effectiveDropOffDate:       null,
    minEffectiveDropOffDate:    null,
    maxEffectiveDropOffDate:    null,
    effectiveDateTime:          null,
    dropOffLocation:            null,
    raRetroDatableCheckIn:      false,
    keyBoxServiceApplicable:    false,
    recoveryMode:               false,
    kms: 						'',
    kmsOnCheck: 				'',
    kmsOnCheckPhoto: 			null,
    currentTankFilling: 		'',
    tankLevelOnCheck: 			null,
    tankLevelOnCheckPhoto: 		null,
    currentBatteryFilling: 		'',
    batteryLevelOnCheck: 		null,
    batteryLevelOnCheckPhoto: 	null,
    enginePowerGroupCode:       '',
    checkOutInMode:             '',
    nonRunningVehicle:          false,
    subRreasonCode:             false
}

export const VEHICLE_STATUS_FORM_VALIDATION_SCHEMA = yup.object().shape({
    effectiveDropOffDate: yup.string()
        .nullable()
        .test({
            name: 'effectiveDropOffDate',
            message: "common.error.required",
            test(value, context) {
                return !['in', 'subIn', 'out'].includes(context.parent.checkOutInMode) ||
                        (['in', 'subIn', 'out'].includes(context.parent.checkOutInMode) && (!context.parent.raRetroDatableKeyBoxCheckIn || (context.parent.raRetroDatableKeyBoxCheckIn && !!value)));
            }
        })
        .test({
            name: 'effectiveDropOffDateInvalidValue',
            message: "common.error.invalidValue",
            test(value, context) {
                return !['in', 'subIn', 'out'].includes(context.parent.checkOutInMode) ||
                        (
                            ['in', 'subIn', 'out'].includes(context.parent.checkOutInMode) &&
                            !!value &&
                            (
                                (!context.parent.raRetroDatableCheckIn && !context.parent.keyBoxServiceApplicable && !context.parent.recoveryMode) ||   // <- esclude dalla validazione i casi di dropoffDate non editabile
                                (
                                    (!!context.parent.raRetroDatableCheckIn || !!context.parent.keyBoxServiceApplicable || !!context.parent.recoveryMode) &&// <- editabile per uno dei 3 motivi
                                    dayjs(value).diff(context.parent.minEffectiveDropOffDate, 'minute') > 0 &&
                                    dayjs(value).diff(context.parent.maxEffectiveDropOffDate, 'minute') <= 0
                                )
                            )
                        );
            }
        }),
    dropOffLocation: yup.object()
        .nullable()
        .test({
            name: 'dropOffLocation',
            message: "common.error.required",
            test(value, context) {
                return !['in', 'subIn'].includes(context.parent.checkOutInMode) || !!value;
            }
        }),
    kmsOnCheck: yup.string()
        .nullable()
        .test({
            name: 'kmsOnCheck',
            message: "common.error.required",
            test(value, context) {
                return  !!value;
            }
        })
        .matches(REG_EXPRESSION_INPUT_FLOAT_NUMBER, "common.error.formatNumber")
        .test({
            name: 'kmsOnCheckMin',
            message: "common.error.invalidValue",
            test(value, context) {
                return !['in', 'subIn', 'out'].includes(context.parent.checkOutInMode) || (parseFloat(context.parent.kms) <= parseFloat(context.parent.kmsOnCheck));
            }
        })
     /*   .test({
            name: 'kmsOnCheckDelta30',
            message: "common.error.30kmsDelta",
            test(value, context) {
                //return (
                context.parent.checkOutInMode === 'out' &&
                (parseFloat(context.parent.kmsOnCheck) - parseFloat(context.parent.kms)) < 31) ||
                context.parent.checkOutInMode === 'in' || context.parent.checkOutInMode === 'subIn';
                return true;
            }
        })*/,
    kmsOnCheckPhoto: yup.object()
        .nullable()
        .test({
            name: 'kmsOnCheckPhoto',
            message: "common.error.required",
            test(value, context) {
                return !['in', 'subIn', 'out'].includes(context.parent.checkOutInMode) ||
                        context.parent.nonRunningVehicle || !!value;
            }
        }),
    tankLevelOnCheck: yup.object()
        .nullable()
        .test({
            name: 'tankLevelOnCheck',
            message: "common.error.required",
            test(value, context) {
                return  !TERMIC_HYBRID_ENGINE_POWER_CODE.includes(context.parent.enginePowerGroupCode) || !!value;
            }
        }),
    tankLevelOnCheckPhoto: yup.object()
        .nullable()
        .test({
            name: 'tankLevelOnCheckPhoto',
            message: "common.error.required",
            test(value, context) {
                return  !['in', 'subIn', 'out'].includes(context.parent.checkOutInMode) ||
                        context.parent.nonRunningVehicle || !TERMIC_HYBRID_ENGINE_POWER_CODE.includes(context.parent.enginePowerGroupCode) ||
                        !!value;
            }
        }),
    batteryLevelOnCheck: yup.object()
        .nullable()
        .test({
            name: 'batteryLevelOnCheck',
            message: "common.error.required",
            test(value, context) {
                return  !ELECTRIC_ENGINE_POWER_CODE.includes(context.parent.enginePowerGroupCode) || !!value;
            }
        }),
    batteryLevelOnCheckPhoto: yup.object()
        .nullable()
        .test({
            name: 'batteryLevelOnCheckPhoto',
            message: "common.error.required",
            test(value, context) {
                return  !['in', 'subIn', 'out'].includes(context.parent.checkOutInMode) ||
                    context.parent.nonRunningVehicle || !ELECTRIC_ENGINE_POWER_CODE.includes(context.parent.enginePowerGroupCode) ||
                    !!value;
            }
        })
});

/** Equipment */
export const EQUIPMENTS_DEFAULT_EVENT_ID = 7;
export const EQUIPMENT_FORM_VALIDATION_SCHEMA = yup.object().shape({
    equipments: yup.array().of(
        yup.object({
            present: yup.boolean()
                .test({
                    name: 'present',
                    message: "common.error.required",
                    test(value, context) {
                        return !!value || !!context.parent.missing;
                    }
                }),
            missing: yup.boolean()
                .test({
                    name: 'missing',
                    test(value, context) {
                        return !!value || !!context.parent.present;
                    }
                }),
            // checkPhoto: yup.string()
            //     .when('missing', {
            //         is: (missing: any) => missing,
            //         then:
            //             yup.string()
            //                 .required("common.error.required")
            //     })
        })
    )
});

export const CHECK_EQUIPMENT_INITIAL_VALUE: ICheckEquipmentsForm = {
    equipments: [],
    comments: []
}

/** Equipment */
export const EQUIPMENT_COMMENT_FORM_VALIDATION_SCHEMA = yup.object().shape({
    note: yup.string()
        .required("common.error.required")
});

export const CHECK_EQUIPMENT_COMMENT_INITIAL_VALUE: IEquipmentCommentForm = {
    note: '',
    createDatetime: null
}

/** DAMAGE SELECTOR */
//initial values
export const DAMAGE_SELECTOR_FORM_INITIAL_VALUES: IDamageSelector = {
    damage: null,
    severity: null
}

/* Validation Schema */
export const DAMAGE_SELECTOR_FORM_VALIDATION_SCHEMA = yup.object().shape({
    damage: yup.object()
        .nullable()
        .required("common.error.required"),
    severity: yup.string()
        .nullable()
        .required("common.error.required")
});

/** EVENT SELECTOR */
//initial values
export const EVENT_SELECTOR_FORM_INITIAL_VALUES: IEventSelector = {
    eventName: null,
    counterpart: false
}

/** Event Form */
//initial values
export const EVENT_CARD_FORM_INITIAL_VALUES: IEventCardForm = {
    card: null
}
export const EVENT_CARD_FORM_VALIDATION_SCHEMA = yup.object().shape({
    card: yup.array().of(
        yup.object({
            eventId: yup.string(),
            counterpart: yup.boolean(),
            counterpartData: yup.object()
                .when('counterpart', {
                    is: true,
                    then: yup.object().shape({
                        claimForm: yup.object()
                            .nullable(),
                        cid: yup.object()
                            .nullable(),
                        plate: yup.string()
                            .required("common.error.required"),
                        place: yup.string()
                            .required("common.error.required"),
                        date: yup.date()
                            .nullable()
                            .typeError('common.error.invalidDate')
                            .required("common.error.required")
                    })
                })
        })
    )
});

/* Validation Schema */
export const EVENT_SELECTOR_FORM_VALIDATION_SCHEMA = yup.object().shape({
    eventName: yup.object()
        .nullable()
        .required("common.error.required"),
});

/** Vehicle Status */
export const RA_VEHICLE_IDENTIFICATION_FORM_INITIAL_VALUE: IRaVehicleIdentificationForm = {
    ra: 	'',
    plate: 	''
}

// Validation Schema
export const RA_VEHICLE_IDENTIFICATION_FORM_VALIDATION_SCHEMA = yup.object().shape({
    ra: yup.string()
        .test({
            name: 'ra',
            message: "common.error.required",
            test(value, context) {
                return !!context.parent.plate || !!value;
            }
        }),
    plate: yup.string()
        .test({
            name: 'plate',
            message: "common.error.required",
            test(value, context) {
                return  !!context.parent.ra || !!value;
            }
        })
});